import { render, staticRenderFns } from "./CustomizerWrapper.vue?vue&type=template&id=61e4c733&"
import script from "./CustomizerWrapper.vue?vue&type=script&lang=js&"
export * from "./CustomizerWrapper.vue?vue&type=script&lang=js&"
import style0 from "./CustomizerWrapper.vue?vue&type=style&index=0&id=61e4c733&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports